export default "__VITE_ASSET__e5354ca7__"